<template>
  <div class="OrderForm">
      <div class="block">
            <span class="demonstration">{{$t('other.a2839')}}：</span>
            <el-date-picker
            size="mini"
            v-model="value7"
            @change="getTiemValue()"
            type="daterange"
            align="right"
            unlink-panels
            value-format="yyyy-MM-dd"
            :range-separator="$t('other.a47')"
            :start-placeholder="$t('other.a45')"
            :end-placeholder="$t('other.a46')"
            :picker-options="pickerOptions2">
            </el-date-picker>
      </div>

        
      <div>
          <div class="ttpom" v-for="(item,index) in btnList" :key="index">
              <div>{{item.desc}}</div>
              <div class="okgnvk">
                <div :class="{'childerBox':true ,'active':dataParams.status == children.value}" 
                v-for="(children,index01) in item.list " :key="index01" @click="handle(children)">{{children.label}}</div>
              </div>
          </div>
      </div>
      <div class="midlng ppo">
          <!-- <span ><el-checkbox @change="targetAll()" v-model="checked"><span class="onmbg">{{!checked ? $t('other.a378') : $t('other.a706')}}({{targetList.length}})</span></el-checkbox></span> -->
          <span class="onmbg">{{amount}}{{$t('other.a707')}}</span>
          <div class="ingknv">
              <el-button size="mini" type="info" @click="exportXml()">{{$t('other.a72')}}</el-button>
              <span style="margin-left:20px;">{{$t('other.a3162')}}：</span>
              <el-input size="medium" style="width:250px;margin-right:20px;" v-model="orderId" @change="getDataByOrderId()" :placeholder="$t('other.a764')"></el-input>
          </div>
          
      </div>
      <div class="orderArea" >
                <div class="noData" v-if="originArr.length == 0">{{$t('other.a3163')}}</div>
				<div v-else class="order-list-item" v-for="(item,index) in originArr" :key="index">
					<div class="list-desc">
                        <!-- <span><el-checkbox v-model="item.checked" @change="targetOrder(item)"></el-checkbox></span> -->
						<el-tooltip  v-if="item.amend"    effect="light" :content="$t('allorders.modified')" placement="bottom">
							<i class="iconfont icon-sign"></i>
						</el-tooltip>
						<el-tooltip  v-if="item.storeFlagId"    effect="light" :content="item.storeFlagDes" placement="bottom">
							<i class="iconfont icon-tuihuo2"></i>
						</el-tooltip>
						<span class="seller">{{$t('pendingorder.orderSn')}}：{{item.orderId}}</span>
						<span class="seller seller-item">{{$t('pendingorder.status')}}：<span class="seller-ppc" style="color:red">{{orderStatus(item)}}</span></span>
						<span class="seller seller-item" >{{$t('lazada.time')}}：{{item.createTime}}</span>
						<span class="seller seller-item">{{$t('homeTwo.Orderactuallypaid')}}({{getCurence(item.country)}})：<span class="seller-ppc">{{item.escrowAmount}}</span></span>
                        <span class="seller seller-item" >{{$t('other.a3164')}}：¥ {{item.totalPrice}}</span>

                        <span class="seller seller-item" style="color:red" >{{$t('other.a3165')}}：¥ {{(item.totalPrice - item.totalPrice*0.05).toFixed(2)}}</span>
                        
                    </div>
					<div class="return-desc">
						<div :class="{'return-item':true}" >
							<div class="pping return-wrpaer">
								<div class="return-item-list " :class="{'unfold' : active !== index}"  v-for="(ttp,index01) in item.items" :key="index01">
									<span class="pic-box" >
										<img v-image-preview :src="ttp.attributeImage ? ttp.attributeImage : ttp.image"  />
									</span>
									<div class="pic-box-desc">
										<div class="desck">{{ttp.itemName}}</div>
										<div class="jinmg" v-if="ttp.storeItem">
											<div class="pic-box-desc-amount" >{{$t('other.a566')}}：{{ttp.storeItem.storeName}}</div>
											<!-- <div class="pic-box-desc-amount" >cusCode：{{ttp.storeItem.cusCode}}（{{ttp.storeItem.component ? $t('allorders.item') : $t('allorders.setmeal')}}）</div> -->
											<div class="pic-box-desc-amount"  v-if="ttp.storeItem.children !== null && !ttp.storeItem.component">
												<div  v-for="(childre,indexTBB) in ttp.storeItem.children" :key="indexTBB">
													<div>{{$t('other.a2460')}}({{childre.cusCode}})：{{childre.skuName}} </div> 
                                                    <div>{{$t('allorders.quantity')}}：x {{childre.rate * ttp.variationQuantityPurchased}}</div>
                                                    <div>{{$t('other.a3166')}}：¥ {{childre.price}} </div> 
												</div>
												</div>
												<div   v-if="ttp.storeItem.children == null">
													<div class="pic-box-desc-amount" >
														sku：{{ttp.storeItem.skuName}}  {{$t('allorders.quantity')}}：{{ttp.variationQuantityPurchased}}
													</div>
													<div class="pic-box-desc-amount" >
														skuName：{{ttp.variationName}}  
													</div>
												</div>
												<div v-if="ttp.storeItem.additions"  >
												<div class="storeItemWrpper"  v-for="(gift,giftIndex) in ttp.storeItem.additions" :key="giftIndex">
													{{$t('other.a497')}}：{{gift.skuName }}（{{gift.cusCode}}）  {{$t('other.a567')}}：{{gift.rate * ttp.variationQuantityPurchased}}
												</div>
										</div>
										</div>
										<div class="jinmg" v-else>
											<div class="pic-box-desc-amount">
											<span class="pic-box-desc-amount-item">sku： {{ttp.storeItem ? ttp.storeItem.skuName : ttp.variationSku ? ttp.variationSku : ttp.variationName}}</span>
											</div>
											<div class="pic-box-desc-amount">
												<span class="pic-box-desc-amount-item">{{$t('homeTwo.Specificationname')}}： {{ttp.storeItem ? ttp.storeItem.variationName ? ttp.storeItem.variationName : description : description}}</span>
											</div>
											<div class="pic-box-desc-amount">
												<span >{{$t('allorders.quantity')}}: x{{ttp.variationQuantityPurchased}}</span>
												<span style="margin-left:20px">{{$t('homeTwo.Sellingprice')}}: {{ttp.price ?  ttp.price : description}}</span>
											</div>
										</div>
										
										<div class="storeItemWrpper pic-box-desc-amount">
											<span >
												{{$t('pendingorder.Inventory')}}:	
											</span>
											<span v-if="ttp.storeItem ">
												{{$t('pendingorder.In_warehouse')}}:
												{{ttp.storeItem ? ttp.storeItem.storeNum : ''}},{{$t('pendingorder.committed')}}:{{ttp.storeItem ? ttp.storeItem.unShipped : ''}},{{$t('pendingorder.on_line')}}:{{ttp.storeItem ? ttp.storeItem.stock : ''}}
											</span>
											
											<!-- <span style="color:red" v-if="ttp.storeItem &&ttp.storeItem.stock <= 0">（库存不足）</span> -->
											<span style="color:red" v-if="!ttp.storeItem && ttp.itemKey!=='DXS|EMPTY_ORDER'">{{$t('allorders.Unboundproduct')}}</span>
											<!-- <span class="bind" v-if="ttp.storeItem && item.platform !== 'DXS' " @click="bindProduct(item,ttp)">
												{{$t('allorders.relationship')}}
											</span> -->
											<!-- <span class="bind" v-if="!ttp.storeItem && ttp.itemKey !=='DXS|EMPTY_ORDER'"  @click="bindProduct(item,ttp)">{{$t('allorders.Tobind')}}</span> -->
											<span style="color:red" v-if="ttp.itemKey =='DXS|EMPTY_ORDER'">{{$t('allorders.emptyproducts')}}</span>
										</div>
                                        <div class="pic-box-desc-amount" v-if="ttp.storeItem">
											<span  v-if="ttp.storeItem.putAway && !ttp.storeItem.component">{{$t('other.a224')}}{{item.userId}}</span>
										</div>
										<div class="pic-box-desc-amount" v-if="ttp.storeItem">
											<span v-if="ttp.storeItem.putAway && !ttp.storeItem.component" class="oriderPutAway">{{$t('other.a254')}}</span>
										</div>
									</div>
								</div>
							</div>
							<div class="pping retrun-reasonr">
								<div class="return-reasonr-desc">{{$t('pendingorder.shopName')}}：{{item.shopName}}</div>
								<div class="return-reasonr-desc">{{$t('allorders.Platform')}}：<span>{{item.platform}}</span></div>
								<div class="return-reasonr-desc">{{$t('homeTwo.Buyermessage')}}：<span>{{item.messageToSeller ? item.messageToSeller : description}}</span></div>
								<div class="return-reasonr-desc">{{$t('homeTwo.Sellernotes')}}：<span>{{item.msgToStore ? item.msgToStore : description}}</span></div>
								
							</div>
							<div class="pping retrun-reasonr">
								<div class="return-reasonr-desc">{{$t('pendingorder.methods')}}：{{item.logistics}}</div>
								<!-- <div class="return-reasonr-desc">{{$t('pendingorder.actually_paid')}}：<span>({{item.currency}}){{item.totalAmount}}</span></div> -->
								<div class="return-reasonr-desc">{{$t('pendingorder.waybill_number')}}：<span>{{item.trackingNo}}</span></div>
								<div class="return-reasonr-desc">{{$t('pendingorder.recipient')}}：{{item.address.name}}</div>
								<div class="return-reasonr-desc">{{$t('pendingorder.phone')}}：{{item.address.phone}}</div>
								
							</div>
							<!-- <div class="pping retrun-reasonr-btn" >
                                <div ><el-button class="btnBox" size="medium" type="primary" @click='changeOrderInfo(item)'>{{$t('other.a713')}}</el-button></div>
                                <div ><el-button class="btnBox" size="medium" :type="!item.emptyOrder ? 'primary' : 'danger'" @click="updateEmptyBag(item)">{{!item.emptyOrder ? $t('homeTwo.Setupanemptypackage') : $t('allorders.Restoreorder')}}</el-button></div>
                                <div ><el-button class="btnBox" @click="showAndhidden(item)" size="medium" :type="!item.hidden ? 'info' : 'danger'">{{item.hidden ? $t('allorders.Accordingorder') : $t('allorders.Hiddenorder')}}</el-button></div>
                                <div  v-if="item.platform == 'DXS'"><el-button class="btnBox" @click="deleteOrderInfo(item)" size="medium" type="info">{{$t('other.a715')}}</el-button></div>
                                
							</div> -->
						</div>
						<div v-if="item.items.length >3 " style="text-align: center;border-top: 1px solid #eee;padding-top: 10px;" @click="ttp01(index)">
						<span style="margin-left: 15px; color: red;cursor: pointer;" v-if="active !== index"><span class="iconfont icon-xia-down"></span>{{$t('allorders.Morehere')}}</span>
						<span style="margin-left: 15px; color: red;cursor: pointer;" v-else><span class="iconfont icon-xiala1"></span>{{$t('allorders.Hideup')}}</span>
						</div>
					</div>
					</div>
				</div>

                <!-- 分页器 -->
				<div class="Pager">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"  :page-sizes="[10, 50, 100, 200]"
					:page-size="dataParams.offset"
					layout=" total,sizes, prev, pager, next, jumper"
					:total="amount">
					</el-pagination>
				  
			   </div>
  </div>
</template>

<script>
import api from '@/api/api'
import orderApi from '@/api/moudles/order.js'
import newOrders from '@/api/moudles/newOrders'
import utils from '@/utils/utils'
export default {
data(){
return{
    dataParams:{},
    checked:false,
    originArr:[],
    targetList:[],
    orderIdList:[],
    active:'',
    hasSucList:[],
    hasError:[],
    loadingTip:0,
    orderId:null,
    amount:0,
    reviewDia:false,
    diaLogWindow:false,
    showAppDia:false,
    userId:null,
    reportOrder:[],
    success:[],
    error:[],
    massCreateOrderDia:false,
    bindOrder:false,
    textDesc:null,
    bindParams:{},
    errorList:[],
    bindError:false,
    autoAudit:false,
    itemKey:0,
    autoReviesList:[],
    autoReviewWarehouse:[],
    isShopsooo:JSON.parse(localStorage.getItem('isShopsooo')),
    description:this.$t("allorders.description"),
    userInfo:JSON.parse(localStorage.getItem('userInfo')),
    pickerOptions2: {
        shortcuts: [{
        text: this.$t("other.a130"),
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
        }
        }, {
        text: this.$t("other.a131"),
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
        }
        }, {
        text: this.$t("other.a132"),
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
        }
        }]
    },
    value7:'',
    btnList:[{
        desc:this.$t('other.a3167'),
        list:[{
            label:this.$t('other.a358'),
            value:-1,
        },{
            label:this.$t('other.a730'),
            value:0,
        },{
            label:this.$t('other.a3168'),
            value:1,
        },{
            label:this.$t('other.a119'),
            value:2,
        },{
            label:this.$t('other.a840'),
            value:3,
        }]
    }]
    
    
}
},

computed:{
    
},
watch:{
    orderList(){
        this.originArr=this.orderList

       
    },

},
created(){
    this.value7=[utils.getRecentDays(-30),utils.getRecentDays(0)]
    this.autoReviewWarehouse=utils.getStore()
    this.userId=JSON.parse(localStorage.getItem('userInfo')).userId
    this.dataParams.timeEnd=utils.CurdateAddoneday(this.value7[1])
    this.dataParams.sortType=0
    this.dataParams.pageSize=10
    this.dataParams.orderId=null
    this.dataParams.status= -1
    this.dataParams.pageNum=1
    this.dataParams.partnerId=null
    this.dataParams.platformType=1
    this.dataParams.type=1
    this.dataParams.timeStart= this.value7[0]
    this.dataParams.userId= this.userInfo.userId
    
    this.getData()

},
methods:{
    getTiemValue(){
        console.log(this.value7)
        this.dataParams.timeStart=this.value7[0]
        this.dataParams.timeEnd=utils.CurdateAddoneday(this.value7[1])
        this.getData()

    },

    handle(item){
        console.log(item)
        this.dataParams.status=item.value
        this.getData()
    },

    getData(){
    orderApi
    .distributeOrder(this.dataParams)
    .then(res => {
    if(res.code === 200 ){
        console.log('desc',res.data)
        
        res.data.list.forEach(p => {
            p.createTime=utils.renderTime(p.createTime)
            p.totalPrice=0
            p.items.forEach(i => {
                if(i.storeItem && i.storeItem.children){
                    p.totalPrice+=i.storeItem.children[0].price*i.variationQuantityPurchased
                }
            })
        })
        console.log('originArr',this.originArr)
        this.originArr=res.data.list
        this.amount=res.data.total
    }else{
    this.$message.warning(res.msg)
    }
    })
    },

    //控制每页显示订单条数
    handleSizeChange(val) {
        this.dataParams.pageSize=parseInt(`${val}`)
        this.handleCurrentChange()
    },
    //显示当前第几页
    handleCurrentChange(val) {
        this.dataParams.pageNum=parseInt(`${val}`) 

        console.log(this.dataParams)
        this.getData()	
        
    },



    





    targetAll(){
        if(this.checked){
            this.originArr.forEach(p => {
                p.checked=true
                this.targetOrder(p)
            })
        }else{
            this.cancelTargetAll()
        }
        
    },

    //取消全选
    cancelTargetAll(){
        this.orderIdList=[]
        this.targetList=[]
        this.originArr.forEach(p => {
            p.checked=false
        })
    },

    exportXml(){
        console.log(this.dataParams)
        let num=this.$t('other.a747') +this.amount+this.$t('other.a3169')

        this.$confirm(num, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            let params=JSON.parse(JSON.stringify(this.dataParams))
            params.pageSize=this.amount
            orderApi
            .distributeOrder(params)
            .then(res => {
            if(res.code === 200 ){
                console.log('desc',res.data)
                // let arr=[]
                
                // res.data.list.forEach(p => {
                //     p.createTime=utils.renderTime(p.createTime)
                //     p.totalPrice=0
                //     p.items.forEach(i => {
                //         if(i.storeItem && i.storeItem.children){
                //             p.totalPrice+=i.storeItem.children[0].price*i.variationQuantityPurchased
                //         }
                //     })
                // })
               
             

                 let arr=[]
                    res.data.list.forEach(p => {
                        p.createTime=utils.renderTime(p.createTime)
                        p.totalPrice=0
                        p.items.forEach((k,index) => {
                            k.totalSku=''
                            k.totalQty=0
                            let num=index+1

                            if(k.storeItem && k.storeItem.children){
                                p.totalPrice+=k.storeItem.children[0].price*k.variationQuantityPurchased
                            }
                            if(k.storeItem && k.storeItem.component ){//单品
                                k.totalSku='sku1'+':' +k.storeItem.skuName  + ' */Qty:' + k.variationQuantityPurchased
                                k.totalQty=k.variationQuantityPurchased
                            }else{//套餐
                                if(k.storeItem && k.storeItem.children){
                                    k.storeItem.children.forEach((j,ttb )=> {
                                        let vdf=ttb+1
                                        k.totalSku+='sku'+ vdf + '('+ j.cusCode +')' + ':' +j.skuName  + ' */Qty:' + k.variationQuantityPurchased *j.rate
                                        k.totalQty+=j.rate*k.variationQuantityPurchased
                                    })
                                }
                            }

                            arr.push({
                                '订单号':p.orderId,
                                '平台订单状态':p.orderStatus,
                                '运单号':p.trackingNo,
                                '收货人':p.address.name,
                                '电话号码':p.address.phone,
                                '详细地址':p.address.state + '/' + p.address.city + '/' +p.address.fullAddress,
                                '产品名称':k.itemName,
                                '单品或套餐':k.storeItem ? k.storeItem.component ? this.$t('other.a251')+k.storeItem.cusCode : this.$t('other.a252') + k.storeItem.cusCode : this.$t('other.a568'),
                                'sku详情':k.totalSku,
                                'sku数量':k.storeItem ? k.storeItem.component ? 1 : k.storeItem.children.length  : this.$t('other.a568'),
                                '购买总数':k.totalQty,
                                '实收':k.price,
                                '配送方式':p.logistics,
                                '下单时间':utils.renderTime(p.createTime),
                                '总供货价':p.totalPrice,
                                '供货商实收':p.totalPrice-p.totalPrice*0.05,
                            })
                        })
                    })
    
                    let list=['订单号','平台订单状态','运单号','收货人','电话号码','详细地址','产品名称','单品或套餐','sku详情','sku数量','购买总数','实收','配送方式','下单时间','总供货价','供货商实收']
                    
                    utils.exPortEXml(arr,list,list)






            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },

    getDataByOrderId(){
        if(this.orderId){
            this.dataParams.orderId=this.orderId.trim()
            console.log(this.dataParams)
            this.getData()
        }else{
            this.dataParams.orderId=null
            this.getData()
        }
    },

    targetOrder(item){
        if(item.checked && !this.orderIdList.includes(item.orderId) ){
            this.orderIdList.push(item.orderId)
            this.targetList.push(item)
        }
        
        if(!item.checked && this.orderIdList.includes(item.orderId) ){
            let num=this.indexValue(this.orderIdList,item.orderId)
            console.log('num',num)
            if(num !== -1){
                this.orderIdList.splice(num,1)
                this.targetList.splice(num,1)
            }
        }
        // console.log('orderIdList',this.orderIdList)   
        console.log('targetList',this.targetList)
    },
    warningTips(text){
        this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a729'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        })
        .then(() => {})
        .catch(() => {})
    },

    deleteOrderInfo(item){
        console.log(item)
        
        this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            item.createTime=null
            item.shipByDate=null
            newOrders
            .delDxsStoreItem(item)
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a565'))
            this.initOrderData()
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },

    orderStatus(item){
        let text=null
        if(item.payTime && item.orderStatus == "READY_TO_SHIP"){
            text=this.$t('other.a730')
        }else if(item.orderStatus == 'UNPAID'){
            text=this.$t('other.a147')
        }else if(item.orderStatus == 'delivered'){
            text=this.$t('other.a119')
        }else if(item.orderStatus == 'canceled'){
            text=this.$t('other.a840')
        }else{
            text=item.orderStatus
        }

        return text
    },




    

  

    

    

           
        

   
			

            getCurence(id){
                return utils.getCurrency(id)
            },

            //剩余发货时间
			 countTime(item){
			 	 if(!item.shipByDate){
			 		 return this.$t('other.a354')
			 	 }
			 		 let lasttime=utils.renderTime(item.shipByDate)
			 		
			 		 let day=''
			 		 let hour=''
			 		 let minute=''
			 		 let second=''
			 		 const end = Date.parse(new Date(lasttime))
			 		 const now = Date.parse(new Date())
			 		 
			 		 if (now >= end) {
			 			day = 0
			 			hour = 0
			 			minute = 0
			 			second = 0
			 			return "0"
			 		 }
			 		 
			 		 const msec = end - now
			 		 let d = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
			 		 let h = parseInt(msec / 1000 / 60 / 60 % 24)//算出小时数
			 		 let m = parseInt(msec / 1000 / 60 % 60)//算出分钟数
			 		 let s = parseInt(msec / 1000 % 60)//算出秒数
			 		
			 		 day = d
			 		 hour = h > 9 ? h : '0' + h
			 		 minute = m > 9 ? m : '0' + m
			 		 second = s > 9 ? s : '0' + s
			 		 const that = this
			 		 
			 		 return day + this.$t('pendingorder.day') + hour+ this.$t('pendingorder.hours') + minute +this.$t('other.a569')
			 				 
			 				
			 },

             // 系统取消订单的剩余时间
			cancelBySystem(time){ 
				let timeStamp=Date.parse(new Date(time))
				timeStamp=timeStamp/1000
				timeStamp += Number(4) *86400
				let newTime=new Date(timeStamp * 1000)
				let d=new Date(newTime)
				let datetime=d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds(); 
				return  utils.countTime(utils.renderTime(newTime))
				
			},
            showShopNameByshopId(id){
                let desc=utils.showShopNameByshopId(id)
				return desc == this.$t("other.a354") ? this.$t('other.a760') : desc

			},

}
}

</script>
<style lang="scss" scoped>

.OrderForm{
    margin-bottom: 100px;

    /deep/ .el-tabs__content{
        min-height: 100vh !important;
    }


    .ingknv{
        display: flex;
        align-items: center;
    }

    .okgnvk{
        display: flex;
    }

    .active{
        color: #fff;
        background-color: #409eff;
    }

    .oriderPutAway{
        color: #fff;
        font-weight: 550;
        display: inline-block;
        background-color: #67C23A;
        text-align: center;
        border-radius: 8px;
        margin: 5px 0;
        box-sizing: border-box;
        padding: 2px 10px;
    }

    .noData{
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        color: #DCDFE6;
        min-height: 100vh;
        line-height: 100vh;
        border-top: 1px solid #eee;
    }



    .ttpom{
        margin: 10px 0;
        display: flex;
        align-items: center;
    }

    .childerBox{
        min-width: 60px;
        text-align: center;
        margin-right: 8px;
        border: 1px solid #eee;
        border-radius: 4px;
        padding: 3px 8px;
        cursor: pointer;
    }

    

    
    .diaOrder{
        display: flex;

        .mnjh{
            width: 100%;
            box-sizing: border-box;
            padding: 5px;
        }

        .plmk{
            text-align: center;
            padding: 10px 0;
        }

        .klij{
            color: rgb(42, 165, 21)
        }

        .uyhkg{
            color: rgb(255, 164, 61);
        }


    }

    .colng{
		display: flex;
		align-items: center;
		margin-left: 30px;
		font-size: 18px;
		cursor: pointer;
		color: #F56C6C;
	}

    .ppo{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px !important;
    }


    img{
        width: 100%;
    }

    .okngjkg{
        display: flex;
        margin: 10px 0;
        align-items: center;
    }

    .onmbg{
        font-size: 16px;
        font-weight: bold;
        margin-right: 30px;
    }

    .notEnough{
        color: #fff;
        background-color: rgb(255, 97, 97);
        box-sizing: border-box;
        padding: 5px 8px;
        border-radius: 3px;
    }

    .bind{
        color: #409EFF;
        box-sizing: border-box;
        padding: 5px 0px;
        border-radius: 5px;
        cursor: pointer;
    }

    .ongk{
        color: #8c8c8c;
        display:flex;
        margin-top:10px;
        font-size:12px;
        align-items:center;
    }

    .Pager{
		position: fixed;
		bottom: 0;
		left: 205px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

    .sensitive{
        color: #fff;
        background-color: rgb(244, 140, 24);
        box-sizing: border-box;
        padding: 5px 8px;
        border-radius: 3px;

    }

    .distributionClass{
        color: #fff;
        background-color: #67C23A;
        box-sizing: border-box;
        padding: 5px 8px;
        border-radius: 3px;
        font-size: 400;
    }



    .midlng{
        margin: 10px 0;
        padding: 0 5px ;
    }

 
    

    .massCreateWrapper{
		text-align: center;
		margin: 20px 0;
	}

    .el-icon-upload{
		font-size: 75px;
		color: #409EFF;
	}

    .masscreateTip{
        text-align: center;
    }

    .dsfdfsf{
        display: flex;
        justify-content: space-between;
    }


    .oningkv{
        box-sizing: border-box;
        padding: 5px 10px;
    }

    .imgbox{
        width: 80px;
        height: 80px;
        overflow: hidden;
        border: 1px solid #eee;
    }

    .orderId{
        background-color: #f6f6f6;
        font-size: 16px;
        font-weight: bold;
        padding: 5px 5px;
    }

    .quatity{
        margin-left: 20px;
    }

    .njngc{
        margin: 0 25px 0 8px;
    }

    .specialpp{
        color: #666!important;
        font-weight: bold;
        box-sizing: border-box;
        padding-bottom: 5px 0!important;

    }
    .el-dropdown{
        margin-left: 10px;
    }

    .storeItemBox{
        width: 350px;
        color: red;
    }
    .childreBox{
        display: flex;
        margin-bottom: 14px;

        
        .skuBox{
            width: 200px;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            color: #666;
        }

        
    }

    

    .ttpItem{
        width: 310px;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
        color: #666;
    }

    .bhbvg{
        text-align: center;
    }
    

    .eddfj{
        display: flex;
        align-items: center;
        justify-content:center;
        flex-direction: column;
    }


    .orderArea{

        .order-list-item {
            position: relative;
            padding-bottom: 10px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
            margin-bottom: 10px;
        }

        .pic-box{
            display: flex;
            flex-direction: column;
            margin: 2px;
            width: 80px;
            height: 80px;
        }

        .return-item-list{
            display: flex;
            align-items: flex-start;
            margin: 5px 0;
            border-bottom: 1px solid #eee;
        }

        .retrun-reasonr{
            margin-left: 30px;
        }

        .return-item{
            display: flex;
            justify-content: space-between;
            box-sizing: border-box;
            padding: 10px;
        }

        .pic-box-desc{
            width: 400px;
            margin-left: 20px;
        }

        .desck{
            font-size: 14px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            color: #666;
            font-weight: bold;
        }

        .pping{
            flex: 1;
        }

        .retrun-reasonr-btn{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
        }

        .seller{
            margin-right: 10px;
            font-size: 16px;
            font-weight: bold;
        }

        .seller-item{
            margin-left: 15px;
            font-size: 14px;
        }


        .list-desc {
            display: flex;
            align-items: center;
            padding: 5px 0;
            margin-left: 5px;
            border-bottom: 1px #eee solid;
        }
        
        .btnBox{
            min-width: 150px;
            margin-bottom: 5px;
        }

        .storeItemWrpper{
            margin-bottom: 3px;
        }

        .jinmg{
            margin-top: 10px;
        }

        .bind{
            color: #409EFF;
            margin-left:20px;
            cursor: pointer;
        }

    }

 



}


</style>